export const SETTING_ROUTE_NAMES = {
  EXPOSE_FEE: 'exposeFee',
}
